module.exports = __webpack_public_path__ + "img/footerBanner.d2a2aed.png";